package org.moxultimate.topwithmox.dashboard.data

import kotlinx.serialization.Serializable
import org.moxultimate.topwithmox.apps.data.AppsResponse
import org.moxultimate.topwithmox.product.data.ProductResponse
import org.moxultimate.topwithmox.shows.data.ShowsResponse
import org.moxultimate.topwithmox.tech.data.TechResponse

/**
 * DashboardLatestResponse
 * Deserialised payload from GET /dashboard/latest.
 * Aggregates the 3 most recently added items from each content category
 * into a single response so the dashboard needs only one network call.
 *
 * @property products   3 latest entries from the products table.
 * @property technology 3 latest entries from the technology table.
 * @property shows      3 latest entries from the shows table.
 * @property apps       3 latest entries from the apps table.
 */
@Serializable
data class DashboardLatestResponse(
    val products: List<ProductResponse> = emptyList(),
    val technology: List<TechResponse> = emptyList(),
    val shows: List<ShowsResponse> = emptyList(),
    val apps: List<AppsResponse> = emptyList(),
)
